document.addEventListener('DOMContentLoaded', function() {
  // Check if "pride" is in the URL
  if (window.location.href.toLowerCase().includes('pride')) {
    // Find all links within elements that have the image-text-component__text-wrapper class
    const textWrapperLinks = document.querySelectorAll('.image-text-component__text-wrapper a');
    
    // Add the button-pride class to each link
    textWrapperLinks.forEach(function(link) {
      link.classList.add('button-pride');
    });
    
    // Also keep the original functionality for wp-element-button elements
    const wpButtons = document.querySelectorAll('.wp-element-button');
    wpButtons.forEach(function(button) {
      button.classList.add('button-pride');
    });
  }
});